import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';
import removeEmpty from '../../../utils/removeEmptyValuesFromObject';

const fetchExpenseQuery = (data) => {
  const cleanedData = removeEmpty(data);
  return axios.post(apiurl?.getexpenseitemlist, cleanedData);
};

const fetchExpenseItems = (data) => {
  return useQuery(['getexpenseitemlist', data], () => fetchExpenseQuery(data), { refetchOnWindowFocus: false });
};

export default fetchExpenseItems;
